import React from "react";
import { Container } from "@material-ui/core";
import { Foot, RightContent, LeftContent } from "./style";

function Footer() {
  return (
    <Container>
      <Foot>
        <RightContent>&copy; Copyright 2020 Prunedge. All rights reserved</RightContent>
        <LeftContent>Powered by: Prunedge iProcurement</LeftContent>
      </Foot>
    </Container>
  );
}

export default Footer;
